import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'
import { authHeaders } from 'utils/authHeaders'

const SLICE_NAME = 'invitedUser'

const initialState = {
	loading: true,
	invitedUser: {},
	error: null,
}

export const inviteNewUser = createAsyncThunk(
	`${SLICE_NAME}/inviteNewUser`,
	async (payload: {
		newUser: { name: string; firstName?: string; email: string }
		// Ignored by the server, which takes the inviter from the session; kept
		// so existing call sites compile unchanged.
		inviterId?: string
		assetType?: string
		assetId?: string
		pushLink?: string
	}) => {
		const { newUser, assetType, assetId, pushLink } = payload

		// This used bare axios with no Authorization header, against a route that
		// requires a session, so every invitation was refused with a 401 and the
		// screens' `payload._id` checks quietly reported nothing (MYD-593).
		const config = {
			headers: {
				'Content-Type': 'application/json',
				...authHeaders(),
			},
		}

		const data = await axios
			.post('/api/invitedusers/', { newUser, assetType, assetId, pushLink }, config)
			.then(res => {
				return res.data
			})

		if (data) {
			return data
		} else {
			return null
		}
	},
)

const invitedUserSlice = createSlice({
	name: SLICE_NAME,
	initialState,
	reducers: {},
	extraReducers: {
		[inviteNewUser.pending as any]: () => ({ ...initialState }),

		[inviteNewUser.fulfilled as any]: (state, action) => ({
			...state,
			invitedUser: action.payload,
			loading: false,
		}),

		[inviteNewUser.rejected as any]: (state, action) => ({
			...state,
			loading: false,
			error: action.error,
		}),
	} as any,
})

export default invitedUserSlice.reducer
